import React from "react";
import { useTranslation } from "react-i18next";
import CommonNotificationSummary from "./CommonNotificationSummary";
const HttpNotificationSummary = ({ ...props }) => {
  const { t } = useTranslation("event_notifications");
  return /* @__PURE__ */ React.createElement(CommonNotificationSummary, { ...props }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, t("http_details.url")), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("code", null, props.notification.config.url))));
};
export default HttpNotificationSummary;
